import { loader } from 'graphql.macro'

export default async function updateTermsAndCondition ({ dataLoaders, variables }) {
  const schema = loader('./updateTermsAndCondition.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      id: variables.id,
      input: variables.input
    }
  })
  return response.UpdateTermsAndCondition
}
